import { CommonModule } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Input,
    NgModule,
    OnInit,
} from '@angular/core';
import { Cms } from '@impact/data';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalVehicleDataService } from '../../core/global-vehicle-data.service';
import { Environment, ENVIRONMENT } from '../../environment/environment';
import { LinkModule } from '../../link/link.module';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { UtilsModule } from '../../utils/utils.module';
import { NewCarsModule } from '../new-cars.module';

@Component({
    selector: 'app-vehicle-variants-leasing-spot',
    templateUrl: './vehicle-variants-leasing-spot.component.html',
})
class VehicleVariantsLeasingSpotComponent implements OnInit {
    @Input() data: Cms.VehicleVariantsLeasingSpot;

    variants: Cms.VehicleVariantDto[] = [];

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private globalVehicleDataService: GlobalVehicleDataService,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {}

    ngOnInit() {
        if (!this.data.vehicleModel) {
            console.error(
                '[BN error: Vehicle model not found for "vehicle variants leasing spot"]'
            );
            return;
        }

        const vehicleModelId = this.data.vehicleModel.id;
        this.globalVehicleDataService
            .getVehicleModelAndVariants(vehicleModelId)
            .subscribe(({ variants }) => {
                this.variants = variants.filter((v) => {
                    const isValid =
                        v.allowLeasingOnBnDk && !!v.leasingPricePerMonth;

                    if (this.environment.site === 'Bjarne Nielsen')
                        return v.showOnBnDk && isValid;

                    if (this.environment.site === 'Bilernes Hus')
                        return v.showOnBilernesHusDk && isValid;

                    return isValid;
                });

                this.changeDetectorRef.markForCheck();
            });
    }
}

@NgModule({
    declarations: [VehicleVariantsLeasingSpotComponent],
    imports: [
        CommonModule,
        RichTextModule,
        NewCarsModule,
        LinkModule,
        TranslateModule.forChild(),
        UtilsModule,
    ],
})
class VehicleVariantsLeasingSpotModule {}

export const LazySpotComponent = VehicleVariantsLeasingSpotComponent;
